import Pagination from '../../../../components/Pagination';
import usePagination from '../../../../hooks/usePagination';
import useUserTrades from '../../../../hooks/web3/trade/useUserTrades';
import ExchangeListsErrowRow from '../ExchangeListsErrorRow';
import ExchangeListsStatus from '../ExchangeListsStatus';
import TradeRow from './TradeRow';

const headers = [
    'Type',
    'Action',
    'Size',
    'Net Value',
    'Collateral',
    'Entry Price',
    'Close Price',
    'Realized PnL',
];

type TradesProps = {
    rowPerPage: number;
};

const Trades: React.FC<TradesProps> = ({ rowPerPage }) => {
    const { userTrades, isLoading, error } = useUserTrades();
    const pagination = usePagination(rowPerPage, userTrades?.length || 0);

    return (
        <>
            <div className='exchange-list-content trades'>
                <ExchangeListsStatus isLoading={isLoading} error={error} message='trades'>
                    <div className='row header'>
                        {headers.map((header, index) => (
                            <div key={index}>{header}</div>
                        ))}
                    </div>
                    {userTrades && userTrades.length ? (
                        pagination
                            .paginateData(userTrades)
                            .map((trade, index) => <TradeRow trade={trade} key={index} />)
                    ) : (
                        <ExchangeListsErrowRow message='You have not made any trades' />
                    )}
                </ExchangeListsStatus>
            </div>
            {userTrades && userTrades.length > rowPerPage ? (
                <Pagination pagination={pagination} />
            ) : null}
        </>
    );
};

export default Trades;
